import { css } from 'styled-components';

export const resetButton = css`
  display: flex;

  border: none;
  margin: 0;
  padding: 0;
  width: auto;
  overflow: visible;

  background: transparent;

  /* inherit font & color from ancestor */
  color: inherit;
  font: inherit;

  /* Normalize line-height. Cannot be changed from normal in Firefox 4+. */
  line-height: normal;

  /* Corrects font smoothing for webkit */
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;

  /* Corrects inability to style clickable input types in iOS */
  -webkit-appearance: none;

  ::-moz-focus-inner {
    border: 0;
    padding: 0;
  }

  :disabled {
    pointer-events: none;
  }

  cursor: pointer;
`;

export const resetInputNumber = css`
  /* Disable arrows */
  /* Chrome, Safari, Edge, Opera */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  /* Firefox */
  &[type='number'] {
    -moz-appearance: textfield;
  }
`;

export const resetLink = css`
  color: inherit;
  text-decoration: inherit;
  cursor: pointer;
`;

export const withDecoratedScroll = css`
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;

  &&::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  &&::-webkit-scrollbar-track {
    background: transparent;
  }
  &&::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 5px;
  }
`;

export const cardTitle = css`
  width: 100%;
  margin: 0;
  font-size: 24px;
  color: #111827;
  text-align: center;

  @media (max-width: 600px) {
    font-size: 22px;
  }
`;
